import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { getTestIds } from '../../../../utils/TestIds';
import { Checkbox } from '../../../Checkbox';
import { DraggableGrid } from '../../../DraggableGrid';
import { isFixedWidthColumn } from '../columns/columnsState';
import { CHECKBOX_GUTTER_WIDTH } from '../table.constants';
import styles from '../table.module.scss';
import { TableHeaderCell } from './TableHeaderCell';
export function TableHeader(param) {
    let { columns, trailingColumn, frozenOffsets = {}, frozenPrefixLength = 0, isScrolledX = false, isScrolledY = false, hasColumnsBeyondEnd, hasActions, minWidth, sort, onSortClick, hasSelection = false, className, plainLabels, selectAll, onResizeStart, onReorder, reorderBi, columnMenu, onToggleFrozen, onHideColumn, resizingColumnId, testId } = param;
    const items = useMemo(()=>columns.map((column, index)=>_object_spread_props(_object_spread({
                id: column.id,
                label: column.label,
                plainLabel: plainLabels,
                width: column.width,
                frozen: index < frozenPrefixLength,
                locked: column.isMain
            }, onSortClick != null && column.column.sortable === true && column.column.bi != null ? {
                sortable: true,
                bi: column.column.bi
            } : {
                sortable: false
            }), {
                hAlign: column.hAlign,
                sortDirection: (sort === null || sort === void 0 ? void 0 : sort.name) === column.id ? sort.direction : undefined,
                isLastFrozen: index === frozenPrefixLength - 1,
                isScrolledX,
                left: frozenOffsets[column.id],
                columnMenu,
                onSortClick,
                onToggleFrozen,
                onHideColumn,
                onResizeStart,
                resizable: !isFixedWidthColumn(column.column),
                isResizing: column.id === resizingColumnId,
                testId
            })), [
        plainLabels,
        columns,
        frozenPrefixLength,
        frozenOffsets,
        isScrolledX,
        sort,
        columnMenu,
        onSortClick,
        onToggleFrozen,
        onHideColumn,
        onResizeStart,
        resizingColumnId,
        testId
    ]);
    const testIds = useMemo(()=>getTestIds(testId), [
        testId
    ]);
    const trailingItem = useMemo(()=>trailingColumn == null ? undefined : {
            id: trailingColumn.id,
            label: trailingColumn.label,
            plainLabel: plainLabels,
            width: trailingColumn.width,
            frozen: false,
            locked: false,
            sortable: false,
            hAlign: trailingColumn.hAlign,
            isLastFrozen: false,
            isScrolledX: false,
            trailing: true,
            testId
        }, [
        trailingColumn,
        plainLabels,
        testId
    ]);
    const template = useMemo(()=>columns.map((column)=>"".concat(column.width, "px")).join(' '), [
        columns
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.header, {
            [styles.scrolledTopEdge]: isScrolledY,
            [styles.resizing]: resizingColumnId != null
        }, className),
        style: {
            minWidth,
            '--dt-trailing-width': trailingColumn == null ? undefined : "".concat(trailingColumn.width, "px")
        },
        "data-testid": testId,
        children: [
            hasSelection && /*#__PURE__*/ _jsx("div", {
                className: styles.checkboxGutter,
                style: {
                    width: CHECKBOX_GUTTER_WIDTH
                },
                children: selectAll != null && /*#__PURE__*/ _jsx(Checkbox, {
                    bi: selectAll.bi,
                    partiallyChecked: selectAll.partiallyChecked === true && !selectAll.checked,
                    checked: selectAll.checked,
                    onChange: (event)=>selectAll.onChange(event.target.checked),
                    testId: testIds.selectAll()
                })
            }),
            onReorder != null && reorderBi != null ? /*#__PURE__*/ _jsx(DraggableGrid, {
                bi: reorderBi,
                items: items,
                itemComponent: TableHeaderCell,
                onReorder: (reordered)=>onReorder(reordered.map((item)=>item.id)),
                dragMode: "withGhost",
                itemMotion: "static",
                itemDropIndicator: "edge",
                itemDraggedAppearance: "dimmed",
                layout: {
                    template
                },
                itemHandlePosition: "inside",
                itemHandleVisibility: "hover",
                itemHandleSize: "small",
                itemDragActivation: "handle",
                className: styles.headerGrid,
                itemClassName: (item)=>cn(styles.headerItem, {
                        [styles.frozenHeaderItem]: item.frozen
                    }),
                itemStyle: (item)=>item.frozen ? {
                        left: item.left
                    } : {},
                testId: testIds.grid()
            }) : /*#__PURE__*/ _jsx("div", {
                className: cn(styles.headerGrid),
                style: {
                    display: 'grid',
                    gridTemplateColumns: template
                },
                children: items.map((item)=>/*#__PURE__*/ _jsx(TableHeaderCell, _object_spread({}, item), item.id))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.trailingGutter
            }),
            hasActions === true && /*#__PURE__*/ _jsx("div", {
                className: cn(styles.actionsGutter, {
                    [styles.scrolledEndEdge]: hasColumnsBeyondEnd === true
                })
            }),
            trailingItem != null && /*#__PURE__*/ _jsx(TableHeaderCell, _object_spread({}, trailingItem))
        ]
    });
}
